import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-template',
  templateUrl: './formly-template.component.html',
  styleUrl: './formly-template.component.scss',
})
export class FormlyTemplateComponent extends FieldType {
  onClick(event) {
    if (this.props.onClick) {
      this.props.onClick(event);
    }
  }
}
